<template lang="html">
    <div class="container">
        <div class="row">
            <!-- New improvements -->
            <div class="col s12 m4">
                <div class="card light-blue darken-2">
                    <div class="card-content white-text">
                        <span class="card-title">Nouvelles propositions  <router-link :to="{ name: 'NewImprovements' }" v-if="niCount" class="btn waves-effect waves-light orange darken-1 pulse right">{{niCount}}</router-link></span>
                        <p>Consulter et valider les dernières améliorations proposées par les utilisateurs</p>
                    </div>
                    <div class="card-action">
                        <router-link :to="{ name: 'NewImprovements' }">Voir ces améliorations</router-link>
                    </div>
                </div>
            </div>
            <!-- current improvements -->
            <div class="col s12 m4">
                <div class="card light-blue">
                    <div class="card-content white-text">
                        <span class="card-title">Améliorations en cours <router-link :to="{ name: 'Improvements' }" v-if="count" class="btn waves-effect waves-light orange lighten-1 right">{{count}}</router-link></span>
                        <p>Consulter la liste des améliorations en cours et leur apporter des modifications</p>
                    </div>
                    <div class="card-action">
                        <router-link :to="{ name: 'Improvements' }">Consulter ces améliorations</router-link>
                    </div>
                </div>
            </div>
            <!-- current improvements -->
            <div class="col s12 m4">
                <div class="card light-blue accent-2">
                    <div class="card-content white-text">
                        <span class="card-title">Archives <router-link :to="{ name: 'Archive' }" v-if="count" class="btn waves-effect waves-light orange lighten-2 right">{{arCount}}</router-link></span>
                        <p>Consulter la liste des améliorations soldées</p>
                    </div>
                    <div class="card-action">
                        <router-link :to="{ name: 'Archive' }">Consulter les archives</router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <!-- edit users -->
            <div class="col s12 m4">
                <div class="card light-blue darken-2">
                    <div class="card-content white-text">
                        <span class="card-title">Editer les utilisateurs</span>
                        <p>Modifier les profils existants et consulter les infos relatives aux utilisateurs</p>
                    </div>
                    <div class="card-action">
                        <router-link :to="{ name: 'EditUsers' }">Gérer les utilisateurs</router-link>
                    </div>
                </div>
            </div>
            <!-- new user -->
            <div class="col s12 m4">
                <div class="card light-blue">
                    <div class="card-content white-text">
                        <span class="card-title">Nouvel utilisateur</span>
                        <p>Créer de nouveaux utilisateurs.</p>
                    </div>
                    <div class="card-action">
                        <router-link :to="{ name: 'Signup' }">Ajouter un  utilisateur</router-link>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import db from '@/firebase/init'
    export default {
        name: 'Admin',
        data(){
            return{
                newImprovements: [],
                niCount:'',
                improvements: [],
                count:'',
                arImprovements: [],
                arCount:''
            }
        },
        created(){
            // get unvalidated improvements
            let ref = db.collection('improvements')
            ref.where('state', '==', 'déclarée').get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    let improvement = doc.data()
                    improvement.id = doc.id
                    this.newImprovements.push(improvement)
                })
            }).then(() => {
                this.niCount = this.newImprovements.length
            })
            // get pending improvements
            ref.where('state', '==', 'ouverte').get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    let improvement = doc.data()
                    improvement.id = doc.id
                    this.improvements.push(improvement)
                })
            })
            ref.where('state', '==', 'en cours').get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    let improvement = doc.data()
                    improvement.id = doc.id
                    this.improvements.push(improvement)
                })
            })
            .then(() => {
                this.count = this.improvements.length
            })
            //get archives
            ref.where('state', '==', 'annulée').get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    let improvement = doc.data()
                    improvement.id = doc.id
                    this.arImprovements.push(improvement)
                })
            })
            ref.where('state', '==', 'cloturée').get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    let improvement = doc.data()
                    improvement.id = doc.id
                    this.arImprovements.push(improvement)
                })
            })
            .then(() => {
                this.arCount = this.arImprovements.length
            })
        }
    }
</script>

<style lang="css" scoped>
.row{
    padding-top: 90px;
}
.card .card-action a:not(.btn):not(.btn-large):not(.btn-small):not(.btn-large):not(.btn-floating){
    color: black !important;
}
.pulse{
    position: unset;
}
</style>
